import {translate} from './translate.js';

export const translateArray = (t, textkeys, params) => {
    return textkeys.map((textkey, index) => translate(t, textkey, {...params, index: (index + 1)}));
};
